// A <form> as a layout container: Enter in a field or a type="submit" Button submits it, and the
// page does not reload. Pass `display="contents"` when it must add no box of its own. Every screen
// that submits fields at once wraps them in a Form instead of writing the element.
import "./config";
import { Column, type ColumnProps } from "./layout";

export interface FormProps extends Omit<ColumnProps, "onSubmit"> {
  onSubmit: () => void;
}

export function Form({ onSubmit, children, ...rest }: FormProps): React.JSX.Element {
  // Tamagui's props do not list `onSubmit`, so the handler travels as a spread.
  const native = {
    noValidate: true,
    onSubmit: (event: React.FormEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onSubmit();
    },
  };
  return (
    // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
    <Column render="form" gap="3" {...native} {...rest}>
      {children}
    </Column>
  );
}
